
import { CreateElement, VNode } from 'vue';
import { Component } from 'vue-property-decorator';

import FormBase from '../modules/FormBase'
import { Item } from '../modules/type';


@Component
export default class FormTs extends FormBase {

    public ledgers: Dropdown[] = [];

    public listLabels: string[] = ['Deposit To', 'note', 'amount'];
    public fromLabels: string[] = ['Deposit From', 'note', 'amount'];
    
    public autoAmountReverce: boolean = true;


    params(): { fromList: Item[] | Error, list: Item[] | Error, [prop: string]: any } | Error {
        const { date, refNo, trNo, type, narration, branchId } = this;
        const fromList = this.costCenterBeforeSubmit(this.fromList, 'Deposit From');
        const list = this.costCenterBeforeSubmit(this.list, 'Deposit To');
        const image_id = this.getImageId();
        return { fromList, list, date, refNo, trNo, type, narration, branchId, image_id };
    }




    fromToRows(h: CreateElement, headers: DataTableHeader[]): VNode[] {
        return [ this.fromEls(h, this.ledgers, headers),this.listEls(h, this.ledgers, headers)]
    }


    afterSubmit(): void {
        if (this.id) { //isEdit
            this.$router.push({ name: "Transaction.deposit.index" })
        } else {
            this.list = [];
            this.addRowTo();
            this.fromList = [];
            this.addRowFrom()
            this.saveAlert('diposit')
        }
    }
    fetchList() {
        this.fetchDropdown({ noUser: true, dropdown: true, groupCode: 121 }, (collection: Dropdown[]) => {
            this.ledgers = collection;
            this.fetchDropdown({ noUser: true, dropdown: true, groupCode: 225 }, (collection: Dropdown[]) => {
                this.ledgers.push(...collection);
            })

        })
    }

    created() {
        if (this.id) { this.show() } else { this.isDotEdit() }
        this.fetchList();
    }


    render(h: CreateElement) {

        return this.renderEl(h)


    }





}